export const EOSName = {
  MACOS: 'macos',
};
